import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Wallet, WarningCircle } from "@phosphor-icons/react";
import api, { money } from "../lib/api";

const LOW = 100;

export default function WalletChip() {
  const [bal, setBal] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const load = useCallback(() => {
    api.get("/organizer/wallet").then((r) => setBal(r.data.balance)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load, location.pathname]);
  useEffect(() => { const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  if (bal === null) return null;
  const low = bal < LOW;

  return (
    <button
      onClick={() => navigate("/organizer/wallet")}
      data-testid="header-wallet-chip"
      title={low ? "Low wallet balance — tap to recharge" : "Services Wallet balance"}
      className={`flex items-center gap-1.5 rounded-full h-9 px-3 text-sm font-semibold border transition-colors btn-press ${low ? "border-amber-500/30 bg-amber-500/10 text-amber-300 hover:bg-amber-500/20" : "border-border bg-card text-foreground hover:bg-muted"}`}>
      {low ? <WarningCircle size={16} weight="fill" /> : <Wallet size={16} />}
      <span data-testid="header-wallet-balance">{money(bal)}</span>
      {low && <span className="hidden sm:inline text-[11px] font-medium">· Low, recharge</span>}
    </button>
  );
}
